import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ewuhktxlxkvvrmgcwsnk.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3dWhrdHhseGt2dnJtZ2N3c25rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ4NDA2NzEsImV4cCI6MjA5MDQxNjY3MX0.XIXjH9c84aqb7NA8WTMluLGHLFsh1yQItFH66cmmaco';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
